import { ENV } from '~/utils/env';
import { isServer } from '~/utils/ssr';

export const ASSIGN_CASHNOTE_PLUS_URL = () => {
  if (isServer()) return '';

  return ENV === 'dev'
    ? `https://dev-app.cashnote.kr/cashnote-plus/api/precheck?referrer=market&postAction=quit&source=market_${window.location.pathname}`
    : `https://app.cashnote.kr/cashnote-plus/api/precheck?referrer=market&postAction=quit&source=market_${window.location.pathname}`;
};

export const PLUS_MEMBERSHIP_SHOWCASE_GROUP_CODE = 'plusmem_crm_group';
export const PLUS_MEMBERSHIP_SHOWCASE_CODE = 'm_sale';

export const BUSINESS_CARD_CHECKOUT_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=checkout&utm_campaign=market';

export const BUSINESS_CARD_PRODUCT_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=product&utm_campaign=market';

export const BUSINESS_CARD_COUPON_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=coupon&utm_campaign=market';

export const PLUS_MEMBERSHIP_STANDARD_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free';

export const PLUS_MEMBERSHIP_FREE_TRIAL_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free';

export const PLUS_MEMBERSHIP_BONUSPACK_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=market-lucky-bonuspack-joined'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=market-lucky-bonuspack-joined';

// 플멤 5% 중복할인 이벤트 localStoage key값
export const PLUS_MEMBERSHIP_EVENT = 'plus-membership-tutorial';
